import React from 'react';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import Icon from 'sharedComponents/Icon';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import AvatarWithBadge from 'sharedComponents/AvatarWithBadge';

import { useTranslation } from 'react-i18next';
import { Skeleton } from '@material-ui/lab';
import { Typography, Checkbox } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { checked, onChecked, loanOfficer, isOnline } = props;

  const isLoanOfficerPresent = isPresent(loanOfficer);
  const loanOfficerName = isLoanOfficerPresent
    ? LoanOfficerPresenter.fullName(loanOfficer)
    : t('models.App.userTypes.loanOfficer');
  const imageUrl = isLoanOfficerPresent ? LoanOfficerPresenter.profileImageUrl(loanOfficer) : '';
  const avatarLabel = isLoanOfficerPresent ? LoanOfficerPresenter.initials(loanOfficer) : '';

  return (
    <div className={classes.container}>
      <Checkbox
        checked={checked}
        onChange={onChecked}
        icon={<Icon name="unchecked" />}
        checkedIcon={<Icon name="checked" />}
      />
      <AvatarWithBadge className={classes.avatar} isOnline={isOnline} imageUrl={imageUrl} label={avatarLabel} />
      <div className={classes.loanOfficerInfo}>
        <Typography variant="subtitle1" color="secondary">
          {t('models.App.userTypes.loanOfficer')}
        </Typography>
        {isLoanOfficerPresent ? (
          <Typography variant="h2" noWrap>
            {loanOfficerName}
          </Typography>
        ) : (
          <Skeleton width={150} height={30} />
        )}
      </div>
    </div>
  );
};

LoanOfficerCard.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChecked: PropTypes.func.isRequired,
  loanOfficer: LoanOfficerPresenter.shape(),
  isOnline: PropTypes.bool.isRequired,
};

LoanOfficerCard.defaultProps = {
  loanOfficer: {},
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/components/BulkMessaging/components/LoanOfficerCard/LoanOfficerCard.js